export const transformPathname = (pathname: string) => {
  return pathname
    .split("/")
    .filter(Boolean)
    .map(segment =>
      segment
        .replace(/-/g, " ")
        .replace(/^(\w)/, (match) => match.toUpperCase())
    )
    .join(" > ");
};

export const formatFileSize = (size: number) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (size === 0) return "0 Byte";
  const i = parseInt(
    String(Math.floor(Math.log(Math.abs(size)) / Math.log(1024))),
  );
  return Math.round((size / Math.pow(1024, i)) * 100) / 100 + " " + sizes[i];
};
